import React from "react";
import { SwitchRoute } from "../../../Components/Route/SwitchRoute";
import { ApprovalsConfigurationRoutes } from "../../../routes/HomeRoutes/ApprovalsConfigurationRoutes";

export const ApprovalsConfigurationLayout = () => (
    <SwitchRoute routes={ApprovalsConfigurationRoutes}/>
);